<template>
    <div>
        <div id="agentHome">
            <section class="section1">
                <h3>
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#se-icon-user"></use>
                    </svg>
                    <span>{{ nickName }}</span>                
                </h3>
                <svg class="icon" aria-hidden="true" @click="logouHandler">
                    <use xlink:href="#se-icon-logout"></use>
                </svg>  
            </section>
            <section class="section2">
                <h3>
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#se-icon-data"></use>
                    </svg>    
                    <span>基本数据</span>            
                </h3>
                <ul>
                    <li>
                        <div>
                            <span>{{ baseData.simTotalCount }}</span>
                            <label>SIM卡总数</label>
                        </div>
                        <div>
                            <span>{{ baseData.orderMonthCount }}</span>
                            <label>本月订单</label>
                        </div>
                        <div>
                            <span>{{ baseData.commissionMonthCount }}</span>
                            <label>本月佣金</label>
                        </div>
                    </li>
                    <li>
                        <div>
                            <span>{{ baseData.orderMoneyMonthCount }}</span>
                            <label>本月订单总额</label>
                        </div>
                        <div>
                            <span>{{ baseData.myCommission }}</span>
                            <label>我的佣金</label>
                        </div>
                        <div>
                            <span>{{ baseData.commissionTotalCount }}</span>
                            <label>累计佣金总额</label>
                        </div>
                    </li>
                </ul>
            </section>
            <section class="section3">
                <h3>
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#se-icon-set"></use>
                    </svg>    
                    <span>快捷操作</span>            
                </h3>
                <ul>
                    <li>
                        <a href="#/agent/secondBack">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#se-icon-second-back"></use>
                            </svg> 
                            <label>秒返设置</label>
                        </a>
                        <a href="#/agent/distribut">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#se-icon-distribut"></use>
                            </svg> 
                            <label>SIM卡分销</label>                        
                        </a>
                        <a href="#/agent/notify">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#se-icon-notify"></use>
                            </svg> 
                            <label>我的公告</label>                        
                        </a>
                    </li>
                    <li>
                        <a href="#/agent/distributRecord">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#se-icon-distribut-record"></use>
                            </svg> 
                            <label>分销记录</label>                                
                        </a>  
                        <a href="#/agent/recharge">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#se-icon-recharge"></use>
                            </svg> 
                            <label>预充值</label>                                
                        </a>
                        <a href="#/agent/rechargeRecord">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#se-icon-recharge-record"></use>
                            </svg> 
                            <label>预充值记录</label>                                
                        </a>    
                    </li>
                    <li>
                        <a href="#/agent/onlineService" v-if="isShowCustomer && baseData.simTotalCount >= 100">
                            <van-icon color="#ffa33a" size="24px" name="service-o" />
                            <label>在线客服</label>                                
                        </a>    
                    </li>
                </ul> 
            </section>
            <section>
                <h3>
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#se-icon-data-statistics"></use>
                    </svg>    
                    <span>近7天订单数</span>     
                    <div id="weekData" ref="weekData" style="height:240px"></div>       
                </h3>
            </section>
        </div>

        <van-popup 
            closeable
            v-model="notifyPopup"
            position="top"
            :style="{ height: '50%' }" 
            v-if="this.$store.state.notifyAlreadyRead == false"
        >
            <div class="notifyPopup">
                <h1 >{{notify.title}}</h1>
                <p >{{notify.content}}</p>
                <div class="alreadyRead" @click="stopDefault" @touchmove="stopDefault">
                    <van-checkbox v-model="alreadyRead" shape="square">
                        <span style="color:#0092ff">我知道了</span>
                    </van-checkbox>
                </div>
            </div>
            
        </van-popup>
    </div>
    
</template>
<script>
import {wxRequest} from '@/api/agent.js';
var echarts = require('echarts/lib/echarts');// 引入 ECharts 主模块
require('echarts/lib/chart/line');// 引入折线图

export default {
    data(){
        return {
            nickName: localStorage.getItem('nickName'),
            baseData: {},
            notify:{
                title: '',
                content:'',
            },
            notifyPopup: true,
            alreadyRead: false,
            isShowCustomer: localStorage.getItem('token'),

            isApp: localStorage.getItem('app') == 1 ? '?app=android' : ''
        }
    },
    methods: {
        logouHandler(){
            this.$router.push('/agent/login' + this.isApp);
        },
        getAgentBaseDataHandler(){
            var data = {
                account: localStorage.getItem('accountName')
            }
            wxRequest("agentCount/info", data, "get").then(res => {
                if(res.data.code == 200){
                    this.baseData = res.data.data;
                    var weekOrderList = this.baseData.weekOrderList;
                    var xAxisData = [], seriesData = [];
                    weekOrderList.forEach(item => {
                        xAxisData.push(item.orderTime)
                        seriesData.push(item.weekNumber)
                    });
                    this.drawEchart(xAxisData, seriesData);
                }else{
                    this.$messagebox.alert(res.data.message);
                }
            })
        },

        stopDefault( e ) { 
            console.log("----------1-----")
            //阻止默认浏览器动作(W3C) 
            if ( e && e.preventDefault ) {
                console.log("----------2-----")
                e.preventDefault(); 
            }
            //IE中阻止函数器默认动作的方式 
            else {
                console.log("----------3-----")
                window.event.returnValue = false; 
            }
            return false; 
        },

        drawEchart(xAxisData, seriesData){
            // 基于准备好的dom，初始化echarts实例
            // var myChart = echarts.init(document.getElementById('testMT'));
            var myChart = echarts.init(this.$refs.weekData);
            // 绘制图表
            myChart.setOption({
                xAxis: {
                    data: xAxisData,
                    boundaryGap: false
                },
                yAxis: {},
                series: [{
                    name: '销量',
                    type: 'line',
                    data: seriesData
                }]
            });
        },

        getNotifyListHandler(){
            this.pageNo += 1;
            var data = {
                pageNo: this.pageNo,
                perPageNum: this.perPageNum,
            }
            wxRequest("agentNotice/list", data, "post").then(res => {
                if(res.data.code == 200){
                    if(res.data.data.resultList!=null&&res.data.data.resultList.length>0){
                        this.notify = res.data.data.resultList[0]
                    }             
                }
            })
        },
    },
    created(){
        if(localStorage.getItem('app') == '1'){
            console.log('是APP')
        }else{
            var appid = process.env.VUE_APP_APPID;
            var redirectUrl = window.location.href;
            var index = redirectUrl.indexOf('?');
            redirectUrl = encodeURIComponent(redirectUrl) 
            if(index < 0){
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`
            }else{
                var search = window.location.search;
                var startIndex = search.indexOf('code');
                var endIndex = search.indexOf('&', startIndex);
                var str = search.slice(startIndex, endIndex);
                var code = str.slice(str.indexOf('=') + 1);
                var data = {
                    code: code
                }
                // wxRequest("sysUser/bind", data, "get")
            }

            this.getNotifyListHandler();    
        }
             
    },
    mounted(){
        this.getAgentBaseDataHandler();
        console.log("===="+this.$store.state.notifyAlreadyRead);
    },

    watch: {
        // 如果 `alreadyRead` 发生改变，这个函数就会运行
        alreadyRead: function () {
            this.$store.state.notifyAlreadyRead = this.alreadyRead;
        },
    },
}
</script>
<style lang="less" scoped>
#agentHome {
    padding: 10px;
    background: #f2f2f2;
    section {
        margin-top: 10px;
        padding: 10px 8px;
        background: #fff;
        border-radius: 10px;
        h3 {
            span {
                display: inline-block;
                vertical-align: top;
                margin: 6px 0 0 5px;
                font-size: 14px;
            }
        }
        &.section1 {
            display: flex;
            justify-content: space-between;  
            margin-top: 0px;  
        }
        &.section2, &.section3 {
            ul {
                li {                    
                    display: flex;
                    /** justify-content: space-around; **/
                    margin: 12px 0;
                    line-height: 1.8em;
                    div,a {
                        width: 33.33%;
                        display: flex;
                        flex-direction: column;
                        text-align: center;
                    }
                    &:first-child {
                        margin-bottom: 16px;
                    }
                }                
            }
        }
        &.section3 {
            ul li svg {
                margin: 0 auto;
                margin-bottom: 5px;
            }
            a {
                color: #2c3e50;
            }
        }
    }
}

.notifyPopup{
    text-align:center;
    width:90%;
    margin: 0 auto;
    margin-top: 60px;

    h1{
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        margin-bottom: 20px;
    }

    p{
        font-size: 14px;
    }

    .alreadyRead{
        margin-top: 10px;
    }
}
</style>

